
import { GenericTableState } from "./types";

export function getDefaultState(): GenericTableState {
	return {
        GenericTableModalRow: null,
		rowHasChanges: false
    }
}
